import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import AdminPage from './components/AdminPage.tsx'
import './index.css'

const normalizedPathname = window.location.pathname.replace(/\/+$/, '') || '/'
const shouldRenderAdminPage = /\/admin$/i.test(normalizedPathname)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {shouldRenderAdminPage ? <AdminPage /> : <App />}
  </React.StrictMode>,
)
